export { Avatar1 } from "./Avatar1";
